const generateRandomNumber = (minimum: number, maximum: number) => Math.floor(Math.random() * (maximum - minimum + 1)) + minimum
export default generateRandomNumber